<ng-container *ngIf="details$ | async as details">
    <div *ngIf="details?.length > 0" class="details-panel">
        <div *ngFor="let element of details; index as i" [ngClass]="{'inactive': !isReviewPeriodOpen, 'panorama-row' : isPanoramaAuraGoals }" class="details-row">
            <div class="field-name">
                <div class="employee-name">{{ element | employeeName }}</div>
                <div class="employee-email">{{ element.email ? element.email : element.userName }}<span *ngIf="element.employeeIdentifier"> | {{ element | employeeIdentifier }}</span></div>
                <div class="inactive-user-label" *ngIf="EmployeeHelper.isEmployeeInactive(element)">{{ 'EMPLOYEE.INACTIVE_USER_LABEL' | translate }}</div>
                <div>{{ element | employeeType }}</div>
            </div>
            <ng-container *ngIf="!isPanoramaAuraGoals">
                <div class="field-details">
                    <div class="field-block" *ngIf="showDeadline(element)">
                        <div class="field-block-title">{{ 'ASSESSMENTS.DEADLINE' | translate }}</div>
                        <div class="field-block-value" [ngClass]="{'date-expired': isDateExpired(element?.deadline)}">
                            {{ getDeadline(element) | datePlain }}
                        </div>
                    </div>

                    <div class="field-block" *ngIf="isFinished(element.status)">
                        <div class="field-block-title">{{ 'ASSESSMENTS.COMPLETED' | translate }}</div>
                        <div class="field-block-value">
                            {{ element?.closedOn | localizedDate }}
                        </div>
                    </div>

                    <div class="field-block" *ngIf="getStatusText(element)">
                        <div class="field-block-title">{{ 'ASSESSMENTS.STATUS' | translate }}</div>
                        <div class="field-block-value">{{ getStatusText(element) }}</div>
                    </div>
                </div>
                <div class="col-action">
                    <button mat-flat-button class="review-button button-bg-alt2 detail-button" *ngIf="isReviewAllowed(element)" [disabled]="EmployeeHelper.isEmployeeInactive(element)" (click)="onReviewClick(element)">{{ 'ASSESSMENTS.FILL_OUT' | translate }}</button>
                    
                    <ng-container *ngIf="isSziluett(element.reviewType) && isFinished(element?.status)">
                        <button mat-flat-button color="accent" [matMenuTriggerFor]="menu" class="review-button detail-button">
                            <mat-icon>keyboard_arrow_down</mat-icon>
                            {{ 'ASSESSMENTS.REPORT' | translate }}
                        </button>
                            <mat-menu #menu="matMenu">
                                <a mat-menu-item title="{{ 'ASSESSMENTS.INDIVIDUAL_REPORT' | translate }}" [routerLink]="['/reports/personality-test/details', element.reviewPeriodEmployeeId]">
                                    <mat-icon fontSet="material-icons-outlined">article_outline</mat-icon> {{ 'ASSESSMENTS.INDIVIDUAL_REPORT' | translate }}
                                </a>
                                <a mat-menu-item title="{{ 'ASSESSMENTS.DIAGRAM_REPORT' | translate }}" [routerLink]="['/reports/personality-test/diagram', element.reviewPeriodEmployeeId]" *ngIf="employee.isSziluettDiagramAllowed">
                                    <mat-icon fontSet="material-icons-outlined">insert_chart_outline</mat-icon> {{ 'ASSESSMENTS.DIAGRAM_REPORT' | translate }}
                                </a>
                            </mat-menu>
                    </ng-container>
                    
                </div>
            </ng-container>

            <div *ngIf="isPanoramaAuraGoals" class="panorama-aura-goals-fields">
                
                <div *ngIf="reviewPeriod.isPositionBasedAssessment || reviewPeriod.isSpecialQuestionSetBasedAssessment" class="panorama-block">
                    <div class="field-details">
                        <div class="field-block">
                            <div class="field-block-title">{{ 'ASSESSMENTS.THREE_SIXTY_ASSESSMENT' | translate }}</div>
                            <div class="field-block-value">{{ getStatusText(element) }}</div>
                        </div>
                        <div class="field-block" *ngIf="showDeadline(element)">
                            <div class="field-block-title">{{ 'ASSESSMENTS.DEADLINE' | translate }}</div>
                            <div class="field-block-value" [ngClass]="{'date-expired': isDateExpired(element?.deadline)}">
                                {{ getDeadline(element) | datePlain }}
                            </div>
                        </div>
                        <div class="field-block" *ngIf="isPanoramaReportAllowed(element)">
                            <div class="gauge-chart">
                                <ngx-gauge type="full"
                                        [value]="panoramaGaugeValue(element) | number: '1.0-0'"
                                        [size]="57"
                                        label=""
                                        foregroundColor="#17A5E3"
                                        [ngClass]="{'gauge-m': gaugeSize >= 160}"
                                        append="%">
                                </ngx-gauge>
                            </div>
                        </div>
                    </div>
                    <div class="col-action">
                        <button mat-flat-button class="review-button button-bg-alt2 detail-button" *ngIf="isReviewAllowed(element)" [disabled]="EmployeeHelper.isEmployeeInactive(element)" (click)="onReviewClick(element)">{{ 'ASSESSMENTS.FILL_OUT' | translate }}</button>
                        <button mat-flat-button class="review-button button-bg-alt1 detail-button" *ngIf="isPanoramaReportAllowed(element)" (click)="onReportClick(element)">{{ 'ASSESSMENTS.REPORT' | translate }}</button>
                    </div>
                </div>
                
                <div class="separator" *ngIf="(reviewPeriod.isPositionBasedAssessment || reviewPeriod.isSpecialQuestionSetBasedAssessment) && isShowGoalAllowed(element)"></div>
                
                <div *ngIf="isShowGoalAllowed(element)" class="panorama-block goalperiod-block">
                    
                    <div class="field-details goal-fields">
                        <div class="field-block">
                            <div class="field-block-title">{{ 'ASSESSMENTS.GOAL_STATUS' | translate }}</div>
                            <div class="field-block-value">{{ getGoalStatusText(element) }}</div>
                        </div>
                        <div class="field-block" *ngIf="isShowGoalIndicatorAllowed(element)">
                            <div class="gauge-chart">
                                <ngx-gauge type="full"
                                        [value]="goalGaugeValue(element)"
                                        [size]="57"
                                        label=""
                                        foregroundColor="#17A5E3"
                                        [ngClass]="{'gauge-m': gaugeSize >= 160}"
                                        append="%">
                                </ngx-gauge>
                            </div>
                        </div>
                    </div>
                    <div class="col-action">
                        <button mat-flat-button class="review-button button-bg-alt4 detail-button" [disabled]="!allowGoalsListPage(element)" *ngIf="isGoalRedirectAllowed(element)" (click)="onGoalsClick(element)" [innerHtml]="'ASSESSMENTS.GOAL_SETTING' | translate"></button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</ng-container>
